import {WorkspaceChat} from "@/pb/api/devplan/types/workspace_chats";

export function workspaceChatTitle(chat: WorkspaceChat): string {
  return chat.title.trim() || "New Chat";
}

export function sortWorkspaceChats(chats: WorkspaceChat[]): WorkspaceChat[] {
  return [...chats].sort((a, b) => chatTimestamp(b) - chatTimestamp(a));
}

export function filterWorkspaceChats(
  chats: WorkspaceChat[],
  {query, favoritesOnly}: {query: string; favoritesOnly: boolean},
): WorkspaceChat[] {
  const normalizedQuery = query.trim().toLocaleLowerCase();
  return chats.filter(chat => {
    if (favoritesOnly && !chat.details?.favorite) return false;
    if (!normalizedQuery) return true;
    return workspaceChatTitle(chat).toLocaleLowerCase().includes(normalizedQuery);
  });
}

export function formatWorkspaceChatTimestamp(date: Date | undefined, now = new Date()): string {
  if (!date || Number.isNaN(date.getTime())) return "—";

  const diffMilliseconds = Math.max(0, now.getTime() - date.getTime());
  const diffMinutes = Math.floor(diffMilliseconds / 60_000);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);
  const nowDay = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  const dateDay = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  const calendarDays = Math.floor((nowDay - dateDay) / 86_400_000);
  const relative = diffMinutes < 1
    ? "now"
    : diffMinutes < 60
      ? `${diffMinutes}m`
      : diffHours < 24
        ? `${diffHours}h`
        : `${diffDays}d`;

  if (calendarDays === 0) return `Today · ${relative}`;
  if (calendarDays === 1) return `Yesterday · ${relative}`;
  return `${date.toLocaleDateString("en-US", {month: "short", day: "numeric"})} · ${relative}`;
}

function chatTimestamp(chat: WorkspaceChat): number {
  return chat.updatedAt?.getTime() ?? chat.createdAt?.getTime() ?? 0;
}
